export default [
  { id: 1, label: 'Admin', access: [1] },
  { id: 6, label: 'Grower', access: [1] },
  { id: 7, label: 'Processor', access: [1] },
  { id: 11, label: 'Retailers', access: [1] },
  { id: 19, label: 'Frontline - Processor (Sales)', access: [1, 7, 19] },
  { id: 20, label: 'Assistant Manager - Retail', access: [1, 11, 20] },
  { id: 21, label: 'Manager - Retail', access: [1, 11, 21] },
  { id: 22, label: 'Asst Manager - Cultivator', access: [1, 6, 22] },
  { id: 23, label: 'Manager - Cultivator', access: [1, 6, 23] },
  { id: 24, label: 'Asst Manager - Processor', access: [1, 7, 24] },
  { id: 25, label: 'Manager - Processor', access: [1, 7, 25] },
  { id: 26, label: 'Frontline Employee - Retail', access: [1, 11, 26] },
  { id: 27, label: 'Grower Marketplace', access: [27] },
  { id: 28, label: 'Retailer Marketplace', access: [28] },
  { id: 29, label: 'Processor Marketplace', access: [29] },
  { id: 30, label: 'Multi-Location Manager', access: [1] },
  { id: 10, label: 'Lab Admin', access: [1] },
  { id: 31, label: 'Frontline - Cultivator (Sales)', access: [1, 6, 31] },
  { id: 32, label: 'Frontline - Cultivator (Batches)', access: [1, 6, 32] },
  { id: 33, label: 'Grower Marketplace - parent', access: [1, 33] },
  { id: 34, label: 'Retailer Marketplace - parent', access: [1, 34] },
  { id: 35, label: 'Processor Marketplace - parent', access: [1, 35] }
]
